import { render, staticRenderFns } from "./RelatedAssetsTooltip.vue?vue&type=template&id=24bc4ed4"
import script from "./RelatedAssetsTooltip.vue?vue&type=script&lang=js"
export * from "./RelatedAssetsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports